module.exports = __webpack_public_path__ + "img/index_base.bf63d8d5.png";